<template>
  <v-container>
  <v-layout row wrap justify-center>
    <v-flex sm8 xs12>
      <v-text-field v-model="channelName" type='text' name='channel-name' id='channel-name' label='Channel Name' prefix='twitch.tv/' @change='fetchData' clearable></v-text-field>
      <v-btn class="mx-2"  color="success" @click="copyId">Copy Id</v-btn>
      <v-btn class="mx-2" color="success" :loading="followedLoading" @click="getFollowed">Get Followed</v-btn>
      <v-btn class="mx-2" color="success" :loading="followersLoading" @click="getFollowers">Get Followers</v-btn>
      <v-btn class="mx-2"  color="success" @click="copyFollowerData">Copy Follower Data</v-btn>
      <v-btn class="mx-2"  color="success" @click="copyFollowedData">Copy Followed Data</v-btn>
      <v-btn class="mx-2"  color="success" @click="clearFollowerCache">Clear Follower Cache</v-btn>
      <br>
      <div v-for="user in followed">
        <a :href="user.url">{{user.display_name}}</a>
      </div>
      Followers: {{followers.length}}
      <br>
      Followed: {{followed.length}}
      <br>
      <json-view :data="user" :maxDepth="5" rootKey="users" :styles="style" />
      <json-view :data="channel" :maxDepth="5" rootKey="channel" :styles="style" />
      <json-view :data="channelBadges" :maxDepth="5" rootKey="channelBadges" :styles="style" />
      <json-view :data="chatBadges" :maxDepth="5" rootKey="chatBadges" :styles="style" />
    </v-flex>
  </v-layout>
  </v-container>
</template>

<script>
import TwitchWrapper from '@/TwitchWrapper'
import { JSONView } from "vue-json-component";

export default {
  name: 'Channel',
  components: { "json-view": JSONView },
  data () {
    return {
      response: '',
      isLoaded: false,
      channel: null,
      followed: [],
      followedLoading: false,
      followers: [],
      followersLoading: false,
      user: null,
      channelBadges: null,
      chatBadges: null,
      maxDepth: 5,
      channelName: this.$router.currentRoute.params.channelName,
      comments: '',
      style: {
        key: "#fdf6e3",
        valueKey: "#fdf6e3",
        string: "#cb4b16",
        number: "#d33682",
        boolean: "#268bd2",
        null: "#b58900",
        arrowSize: "6px"
      },
      twitch: new TwitchWrapper(this.$root.$data.clientId),
    }
  },
  created () {
    this.fetchData()
  },
  watch: {
    '$route': 'fetchData'
  },
  methods: {
    getFollowed() {
      if(this.followedLoading){ return }
      this.followedLoading = true
      this.followed = []
      this.twitch.GetFollowedChannels(this.user._id).then(f => {
        this.followed = f
        this.followedLoading = false
      })
    },
    getFollowers() {
      if(this.followersLoading){ return }
      this.followersLoading = true
      this.followers = []
      this.twitch.GetChannelFollowers(this.user._id).then(f => {
        this.followers = f
        this.followersLoading = false
      })
    },
    copyId() {
      //navigator.clipboard.writeText(this.followed.map(f => f.followed_at + ", " + f.display_name).join('\n'))
      navigator.clipboard.writeText(this.user._id)
    },
    copyFollowedData() {
      //navigator.clipboard.writeText(this.followed.map(f => f.followed_at + ", " + f.display_name).join('\n'))
      navigator.clipboard.writeText(JSON.stringify(this.followed))
    },
    copyFollowerData() {
      navigator.clipboard.writeText(this.followers.map(f => f.created_at + ", " + f.user.display_name).join('\n'))  
    },
    clearFollowerCache() {
      localStorage.removeItem('follows_' + this.user._id)
    },
    fetchData () {
      this.$router.push({params: {channelName: this.channelName}})

      this.twitch.GetUser(this.channelName).then(u => {
        this.user = u
        
        this.twitch.GetChannelBadges(u.users[0]._id).then(b => {
            this.channelBadges = b
        })
        this.twitch.GetChatBadges(u.users[0]._id).then(b => {
            this.chatBadges = b
        })
      })
    },
  }
}
</script>